<!-- BapFeedbackContent.vue -->
<template>
  <section
    class="flex flex-col items-center justify-center w-full h-[90vh] px-4 bg-transparent overflow-auto"
  >
    <!-- Profile Section -->
    <div class="profile-section flex flex-col items-center text-center">
      <img
        src="@/assets/img/bap.jpg"
        alt="JEVANNEL G. BORLIO"
        class="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-full border-4 border-gray-300 mb-4 object-cover"
      />
      <h1 class="text-lg sm:text-xl md:text-2xl font-bold text-white">
        JEVANNEL G. BORLIO
      </h1>
      <h2 class="text-sm sm:text-base md:text-lg text-white mb-5">
        Assistant Professor I
      </h2>
    </div>

    <!-- Text + Image Section -->
    <div
      class="flex flex-col-reverse xl:flex-row items-center xl:items-stretch justify-center gap-6 xl:gap-10 mt-6 md:mt-8 w-full max-w-6xl"
    >
      <!-- Text Section -->
      <div class="flex-1 bg-transparent flex items-start justify-center">
        <p
          class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
        >
          The implementation of the DNSC-LMS has fundamentally reshaped my
          perspective on asynchronous learning. Initially, I had concerns about
          student engagement, fearing that the purely digital link of uploaded
          modules and instructional videos might create distance. However, these
          worries have completely dissipated, replaced by a deep appreciation
          from both the faculty and the students.
        </p>
      </div>

      <!-- Image Section -->
      <div class="flex-1 flex justify-center items-stretch">
        <img
          src="@/assets/img/bap-1.jpg"
          alt="JEVANNEL G. BORLIO"
          class="w-full lg:h-[220px] h-full rounded-2xl border-2 border-gray-300 object-cover shadow-lg"
        />
      </div>
    </div>

    <!-- Additional Paragraphs -->
    <div class="flex flex-col space-y-4 mt-2 md:mt-4 lg:mt-4 max-w-4xl">
      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        My students have expressed gratitude for the LMS, especially as it
        ensures continuity in learning despite interruptions to synchronous
        sessions. This system, which is a core component of Davao del Norte
        State College’s Unified Digital Ecosystem, has effectively bridged the
        gap in education delivery. My personal, meaningful experience with this
        system stands as proof that DNSC’s investment in digital transformation
        is a crucial and great tool for maintaining quality education.
      </p>
      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        As a program chairperson, my favorite features are the robust tools for
        setting up quizzes and the efficient ability to import learning
        materials from other established courses. Beyond the classroom, the
        monitoring capabilities are invaluable, providing an efficient way to
        track and ensure that faculty members under my department are
        consistently uploading and organizing their learning resources for our
        students. The LMS has truly streamlined our academic operations.
      </p>
    </div>

    <!-- Close Button -->
    <button
      @click="$emit('close')"
      class="mt-5 px-8 py-3 bg-white/20 backdrop-blur-md text-white font-semibold rounded-full border border-white/40 shadow-lg hover:bg-red-600 hover:text-white hover:border-red-600 transition duration-300 ease-in-out"
    >
      Close
    </button>
  </section>
</template>

<script>
export default {
  name: "BapFeedbackContent",
};
</script>

<style scoped>
/* ✅ Custom responsive spacing for the profile section */
.profile-section {
  margin-top: 54rem; /* default for mobile */
}

@media (min-width: 640px) {
  /* sm screens (small tablets, large phones) */
  .profile-section {
    margin-top: 8rem;
  }
}

@media (min-width: 768px) {
  /* md screens (tablets) */
  .profile-section {
    margin-top: 36rem;
  }
}

@media (min-width: 1024px) {
  /* lg screens (laptops/desktops) */
  .profile-section {
    margin-top: 2rem;
  }
}

@media (min-width: 1280px) {
  /* xl screens (large desktops) */
  .profile-section {
    margin-top: 4rem;
  }
}

/* Smooth scrollbar for overflow sections */
section::-webkit-scrollbar {
  width: 8px;
}
section::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 10px;
}
</style>
